import React from "react";
import styled from "styled-components";

import Text from "../basic/Text";
import Button from "../basic/Button";

import assets from "@images/assets";
import theme from "@theme";

const { colors, breakPoints, forms } = theme;

const FormBoxShadow = styled.div`
	width: 100%;
	position: relative;
	:after {
		position: absolute;
		content: "";
		width: 100%;
		height: 85%; /* Half of the original height */
		bottom: 0;
		left: 0;
		box-shadow: -30px 30px 0 0 #e5e5e5;
		z-index: 0;
		@media only screen and (max-width: ${breakPoints.medium}) {
			display: none;
		}
	}
`;
const FormWrapper = styled.div`
	width: 100%;
	position: relative;
	z-index: 3;
	background-color: ${colors.white};
	color: ${colors.black};
	border: none;
	padding: 60px;
	border-radius: ${forms.borderRadius};
	box-shadow: 0 2px 34px 0 rgba(0, 0, 0, 0.13);
	@media only screen and (max-width: ${breakPoints.medium}) {
		width: 100vw;
		position: relative;
		margin-left: -50vw;
		left: 50%;
	}
`;

const WebinarHeader = styled(Text)`
	color: #fc5b30;
	margin-bottom: 10px;
	font-size: 28px;
	line-height: 30px;
`;

const WebinarLink = styled(Button)`
	margin: 20px auto 0;
	display: block;
`;

export default React.memo(({ buttonLink, headerText, buttonText }) => {
	return (
		<FormBoxShadow>
			<FormWrapper>
				<WebinarHeader component="h3" className="form-subheadline">
					{headerText}
				</WebinarHeader>
				<WebinarLink link={buttonLink}>{buttonText}</WebinarLink>
			</FormWrapper>
		</FormBoxShadow>
	);
});

//
